import React, { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Grid,
  Box,
  Paper,
  FormHelperText,
  IconButton,
  Tooltip,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const cleanFileName = (filePath) => {
  if (!filePath) return '';
  if (filePath.startsWith('http')) {
    return decodeURIComponent(filePath.split('/').pop().replace(/^\d+[-_]/, ''));
  }
  return filePath;
};

const Addpersonal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const isEditMode = !!id || location.state?.isEdit;


  const [errors, setErrors] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);
  const [companyCountry, setCompanyCountry] = useState("India");
  const [nationalIdLabel, setNationalIdLabel] = useState("PAN / Aadhaar");

  const [formData, setFormData] = useState({
    employmentStatus: "Active",
    // company_registration_no: "12345",
    personalPhoto: null,

    personalDetails: {
      firstName: "",
      lastName: "",
      fatherName: "",
      personalemail: "",
      dateOfBirth: "",
      anniversary: "",
      gender: "",
      panNumber: "",
      panCardFile: null,
      adharCardNumber: "",
      adharCardFile: null,
    },
    contactInfo: {
      phoneNumber: "",
      houseNumber: "",
      street: "",
      state: "",
      area: "",
      city: "",
      pinCode: "",
    },
    emergencyContact: {
      mobile: "",
      landline: "",
    },
    insurance: {
      individualInsurance: "",
      groupInsurance: "",
    },
    nominations: [{ name: "", relationship: "", age: "" }],
    qualifications: [{ degree: "", institution: "", year: "", file: null }],
    certificates: [{ name: "", issuedBy: "", date: "", file: null }],
  });

  const validatePAN = (pan) => {
    if (!companyCountry || companyCountry.toLowerCase() === "india") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
      return panRegex.test(pan);
    }
    return pan && pan.length >= 3; // Basic validation for non-Indian IDs
  };

  const validateAadhar = (aadhar) => {
    const aadharRegex = /^\d{12}$/;
    return aadharRegex.test(aadhar);
  };

  const validatePhone = (phone) => {
    if (!phone) return false;
    const cleanPhone = phone.toString().trim();
    if (!companyCountry || companyCountry.toLowerCase() === "india") {
      const phoneRegex = /^\d{10}$/;
      return phoneRegex.test(cleanPhone);
    }
    const phoneRegex = /^\d{6,15}$/;
    return phoneRegex.test(cleanPhone);
  };

  const validatePinCode = (pincode) => {
    if (!companyCountry || companyCountry.toLowerCase() === "india") {
      const pincodeRegex = /^\d{6}$/;
      return pincodeRegex.test(pincode);
    }
    return pincode && pincode.trim().length >= 3;
  };

  const validateEmail = (email) => {

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
      return {
        isValid: false,
        message: "Invalid email format"
      };
    }


    const commonDomains = {
      "gmail.co": "gmail.com",
      "yahoo.co": "yahoo.com",
      "hotmail.co": "hotmail.com",
      "outlook.co": "outlook.com"
    };

    const domain = email.split("@")[1];

    if (commonDomains[domain]) {
      return {
        isValid: false,
        message: `Did you mean ${email.split("@")[0]}@${commonDomains[domain]}?`,
        suggestedEmail: `${email.split("@")[0]}@${commonDomains[domain]}`
      };
    }

    return {
      isValid: true,
      message: "Valid email"
    };
  };
  const validateName = (name) => {
    const nameRegex = /^[a-zA-Z\s]+$/;
    return nameRegex.test(name.trim()) && name.trim().length > 0;
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.personalDetails.firstName) {
      newErrors.firstName = "First name is required";
    } else if (!validateName(formData.personalDetails.firstName)) {
      newErrors.firstName = "First Name should contain only alphabetic characters";
    }

    // Replace the existing lastName validation  
    if (!formData.personalDetails.lastName) {
      newErrors.lastName = "Last name is required";
    } else if (!validateName(formData.personalDetails.lastName)) {
      newErrors.lastName = "Last Name should contain only alphabetic characters";
    }

    // Replace the existing fatherName validation
    if (!formData.personalDetails.fatherName) {
      newErrors.fatherName = "Father's name is required";
    } else if (!validateName(formData.personalDetails.fatherName)) {
      newErrors.fatherName = "Father Name should contain only alphabetic characters";
    }

    if (!formData.personalPhoto && !previewUrl) {
      newErrors.personalPhoto = "Personal photo is required";
    }



    if (formData.employee_id || formData.personalDetails?.employee_id) {
      const empId = (formData.employee_id || formData.personalDetails?.employee_id || "").trim();
      const idRegex = /^[A-Za-z0-9_-]{3,20}$/;
      if (empId && !idRegex.test(empId)) {
        newErrors.employee_id = "Employee ID must be 3-20 alphanumeric characters (hyphens and underscores allowed)";
      }
    }

    if (!formData.personalDetails.personalemail) {
      newErrors.personalemail = "Email is required";
    } else {
      const emailValidation = validateEmail(formData.personalDetails.personalemail);
      if (!emailValidation.isValid) {
        newErrors.personalemail = emailValidation.message;
      }
    }

    if (!formData.personalDetails.gender) {
      newErrors.gender = "Gender is required";
    }

    if (!formData.personalDetails.dateOfBirth) {
      newErrors.dateOfBirth = "Date of Birth is required";
    }

    if (!formData.personalDetails.panNumber) {
      newErrors.panNumber = `${nationalIdLabel} is required`;
    } else if (!validatePAN(formData.personalDetails.panNumber)) {
      newErrors.panNumber = (!companyCountry || companyCountry.toLowerCase() === "india") ? "Invalid PAN format (e.g., ABCDE1234F)" : "Invalid ID format";
    }

    if (!formData.personalDetails.panCardFile && !isEditMode) {
      newErrors.panCardFile = `${nationalIdLabel} document is required`;
    }

    if (!companyCountry || companyCountry.toLowerCase() === "india") {
      if (!formData.personalDetails.adharCardNumber) {
        newErrors.adharCardNumber = "Aadhar Number is required";
      } else if (!validateAadhar(formData.personalDetails.adharCardNumber)) {
        newErrors.adharCardNumber = "Invalid Aadhar format (12 digits)";
      }

      if (!formData.personalDetails.adharCardFile && !isEditMode) {
        newErrors.adharCardFile = "Aadhar Card document is required";
      }
    }


    if (!formData.contactInfo.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!validatePhone(formData.contactInfo.phoneNumber)) {
      newErrors.phoneNumber = (!companyCountry || companyCountry.toLowerCase() === "india") ? "Valid 10-digit phone number is required" : "Valid phone number is required";
    }

    if (!formData.contactInfo.houseNumber) {
      newErrors.houseNumber = "House number is required";
    }

    if (!formData.contactInfo.street) {
      newErrors.street = "Street is required";
    }

    if (!formData.contactInfo.state) {
      newErrors.state = "State is required";
    }

    if (!formData.contactInfo.area) {
      newErrors.area = "Area is required";
    }

    if (!formData.contactInfo.city) {
      newErrors.city = "City is required";
    }

    if (!formData.contactInfo.pinCode) {
      newErrors.pinCode = "Pin code is required";
    } else if (!validatePinCode(formData.contactInfo.pinCode)) {
      newErrors.pinCode = (!companyCountry || companyCountry.toLowerCase() === "india") ? "Valid 6-digit pin code is required" : "Valid zip/pin code is required";
    }


    if (!formData.emergencyContact.mobile) {
      newErrors.emergencyMobile = "Emergency mobile number is required";
    } else if (!validatePhone(formData.emergencyContact.mobile)) {
      newErrors.emergencyMobile = (!companyCountry || companyCountry.toLowerCase() === "india") ? "Valid 10-digit mobile number is required (numbers only)" : "Valid mobile number is required (numbers only)";
    }

    if (formData.emergencyContact.landline && !/^\d{6,15}$/.test(formData.emergencyContact.landline.trim())) {
      newErrors.emergencyLandline = "Landline must contain only digits (6-15 digits)";
    }

 

    const hasValidNomination = formData.nominations.some(
      (nom) => nom.name && nom.relationship && nom.age
    );

    if (!hasValidNomination) {
      newErrors.nominations = "At least one complete nomination is required";
    }


    const hasValidQualification = formData.qualifications.some(
      (qual) => qual.degree && qual.institution && qual.year
    );

    if (!hasValidQualification) {
      newErrors.qualifications = "At least one complete qualification is required";
    }


  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDirectChange = (e, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleChange = (e, section, key) => {
    let value = e.target.value;
    if (key === 'phoneNumber' || key === 'mobile' || key === 'landline') {
      value = value.replace(/\D/g, '').slice(0, 15);
    }
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value,
      },
    }));
  };

  const handleArrayChange = (section, index, field) => (event) => {
    setFormData((prev) => {
      const updatedSection = [...prev[section]];
      updatedSection[index][field] = event.target.value;
      return { ...prev, [section]: updatedSection };
    });
  };

  const handleFileUpload = (e, section, key) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [key]: file,
        },
      }));
    }
  };

  const handlePersonalPhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {

      const url = URL.createObjectURL(file);
      setPreviewUrl(url);

      setFormData((prev) => ({
        ...prev,
        personalPhoto: file,
      }));
    }
  };

  const handleArrayFileUpload = (section, index, field) => (event) => {
    setFormData((prev) => {
      const updatedSection = [...prev[section]];
      updatedSection[index] = {
        ...updatedSection[index],
        file: event.target.files[0]
      };
      return { ...prev, [section]: updatedSection };
    });
  };

  const addEntry = (section, newEntry) => {
    setFormData((prev) => ({
      ...prev,
      [section]: [...prev[section], newEntry],
    }));
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      const editId = id || location.state?.employee_id;

      if (editId) {
        try {
          const token = localStorage.getItem("token"); // get JWT token
          if (!token) {
            alert("No authentication token found. Please log in.");
            return;
          }

          const payload = JSON.parse(atob(token.split('.')[1]));
          const company_id = payload.company_id;
          const { data } = await axios.get(`${API_URL}/api/employees/${editId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (data.success) {
            const employeeData = data.data;
            
            setFormData({
              employee_id: editId,
              employmentStatus: employeeData.employmentStatus,
              // company_registration_no: employeeData.company_registration_no,
              personalPhoto: employeeData.personalPhoto,
              personalDetails: {
                firstName: employeeData.firstName,
                lastName: employeeData.lastName,
                fatherName: employeeData.fatherName,
                personalemail: employeeData.personalemail,
                dateOfBirth: employeeData.dateOfBirth?.split('T')[0] || '',
                anniversary: employeeData.anniversary?.split('T')[0] || '',
                gender: employeeData.gender,
                panNumber: employeeData.panNumber,
                panCardFile: employeeData.panCardFile || null,
                adharCardNumber: employeeData.adharCardNumber,
                adharCardFile: employeeData.adharCardFile || null
              },
              contactInfo: {
                phoneNumber: employeeData.phoneNumber,
                houseNumber: employeeData.houseNumber,
                street: employeeData.street,
                state: employeeData.state || '',
                area: employeeData.area,
                city: employeeData.city,
                pinCode: employeeData.pinCode
              },
              emergencyContact: {
                mobile: employeeData.mobile,
                landline: employeeData.landline,
              },
              insurance: {
                individualInsurance: employeeData.individualInsurance,
                groupInsurance: employeeData.groupInsurance,
              },
              nominations: employeeData.nominations || [{ name: "", relationship: "", age: "" }],
              qualifications: employeeData.qualifications || [{ degree: "", institution: "", year: "", file: null }],
              certificates: employeeData.certificates || [{ name: "", issuedBy: "", date: "", file: null }]
            });


            if (employeeData.personalPhoto) {
              const photoPath = employeeData.personalPhoto.trim();
              const url = photoPath.startsWith("http") ? photoPath : `${API_URL}/uploads/${photoPath.replace(/^\/+/g, "")}`;
              setPreviewUrl(url);
            }
          }
        } catch (error) {
          alert("Error loading employee data");
        }
      }
    };

    const fetchCompanyData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.company_id) {
          const { data } = await axios.get(`${API_URL}/api/cmp/${payload.company_id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (data.success && data.data?.country) {
            setCompanyCountry(data.data.country);
            if (data.data.nationalIdLabel) setNationalIdLabel(data.data.nationalIdLabel);
          }
        }
      } catch (error) {
        // console.error("Error fetching company country:", error);
      }
    };

    fetchCompanyData();
    if (isEditMode) fetchEmployeeData();
  }, [id, location.state, isEditMode]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      window.scrollTo(0, 0);
      return;
    }

    try {
      // Decode JWT token to get user id and role
      const token = localStorage.getItem('token'); // Assuming token is stored as 'token'
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const userId = payload.id;
      const userRole = payload.role;
      const company_id = payload.company_id;

      const formDataToSend = new FormData();
      const editId = id || location.state?.employee_id;

      formDataToSend.append("employmentStatus", formData.employmentStatus);
      // formDataToSend.append("company_registration_no", formData.company_registration_no);


      if (formData.personalPhoto) {
        formDataToSend.append("personalPhoto", formData.personalPhoto);
      }

      formDataToSend.append("personalDetails", JSON.stringify(formData.personalDetails));
      formDataToSend.append("contactInfo", JSON.stringify(formData.contactInfo));
      formDataToSend.append("nominations", JSON.stringify(formData.nominations));
      formDataToSend.append("qualifications", JSON.stringify(formData.qualifications));
      formDataToSend.append("certificates", JSON.stringify(formData.certificates));
      formDataToSend.append("insurance", JSON.stringify(formData.insurance));
      formDataToSend.append("emergencyContact", JSON.stringify(formData.emergencyContact));

      if (formData.personalDetails.panCardFile) {
        formDataToSend.append("panCardFile", formData.personalDetails.panCardFile);
      }
      if (formData.personalDetails.adharCardFile) {
        formDataToSend.append("adharCardFile", formData.personalDetails.adharCardFile);
      }

      formData.qualifications.forEach((qual, index) => {
        if (qual.file) {
          formDataToSend.append(`qualificationFile`, qual.file);
        }
      });

      formData.certificates.forEach((cert, index) => {
        if (cert.file) {
          formDataToSend.append(`certificationFile`, cert.file);
        }
      });

      const baseUrl = isEditMode
        ? `${API_URL}/api/updateEmployee/${editId}`
        : `${API_URL}/api/addEmployee`;

      const url = `${baseUrl}?id=${userId}&role=${userRole}&company_id=${company_id}`;

      const response = await axios({
        method: isEditMode ? "put" : "post",
        url: url,
        data: formDataToSend,
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        const { employee_id, companyemail } = response.data.data;
        alert(isEditMode ? "Updated successfully!" : `Employee added successfully!\nEmployeeId: ${employee_id}\nCompanyEmail: ${companyemail}`);
        navigate("/addfinancial", {
          state: {
            employee_id: employee_id,
            isEdit: isEditMode
          }
        });
      }
    } catch (error) {
      alert(`Error: ${error.response?.data?.message || error.message}`);
    }
  };

  const FieldTooltip = ({ title }) => (
    <Tooltip title={title} arrow placement="top">
      <IconButton size="small" sx={{ color: 'gray', ml: 1 }}>
        <InfoIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );

  return (
    <Box sx={{ maxWidth: 1500, margin: 'auto', padding: 3 }}>
      <Typography variant="h4" gutterBottom align="center" fontWeight="bold">
        {isEditMode ? "Edit Personal Details" : "Add Personal Details"}
      </Typography>

      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Grid container spacing={2}>
          {isEditMode && (
            <Grid item xs={6}>
              <TextField
                label="Employee ID"
                fullWidth
                value={formData.employee_id || ''}
                disabled={true}
              />
            </Grid>
          )}
          <Grid item xs={isEditMode ? 6 : 12}>
            <FormControl fullWidth>
              <InputLabel>Employment Status</InputLabel>
              <Select
                label="Employment Status"
                value={formData.employmentStatus}
                onChange={(e) => handleDirectChange(e, 'employmentStatus')}
                required>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Resigned">Resigned</MenuItem>
                <MenuItem value="Deceased">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Personal Details
          <FieldTooltip title="Basic personal information of the employee" />
        </Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="First Name"
                  fullWidth
                  value={formData.personalDetails.firstName}
                  onChange={(e) => handleChange(e, 'personalDetails', 'firstName')}
                  required
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Last Name"
                  fullWidth
                  value={formData.personalDetails.lastName}
                  onChange={(e) => handleChange(e, 'personalDetails', 'lastName')}
                  required
                  error={!!errors.lastName}
                  helperText={errors.lastName}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Father Name"
                  fullWidth
                  value={formData.personalDetails.fatherName}
                  onChange={(e) => handleChange(e, 'personalDetails', 'fatherName')}
                  required
                  error={!!errors.fatherName}
                  helperText={errors.fatherName}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Email"
                  fullWidth
                  value={formData.personalDetails.personalemail}
                  onChange={(e) => handleChange(e, 'personalDetails', 'personalemail')}
                  required
                  error={!!errors.personalemail}
                  helperText={errors.personalemail}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth error={!!errors.gender}>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    label="Gender"
                    value={formData.personalDetails.gender}
                    onChange={(e) => handleChange(e, 'personalDetails', 'gender')}
                    required
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                  {errors.gender && <FormHelperText>{errors.gender}</FormHelperText>}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={3} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
            <Typography variant="subtitle1" gutterBottom>
              Personal Photo
              <FieldTooltip title="Upload a passport-sized photo (JPEG/PNG, max 2MB)" />
            </Typography>
            <Box
              sx={{
                width: 120,
                height: 120,
                border: errors.personalPhoto ? '1px solid red' : '1px dashed grey',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                mb: 2,
                position: 'relative'
              }}
            >
              {previewUrl ? (
                <img
                  src={previewUrl}
                  alt="Profile Preview"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No Photo
                </Typography>
              )}
            </Box>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="photo-upload"
              type="file"
              onChange={handlePersonalPhotoUpload}
              required
            />
            <label htmlFor="photo-upload">
              <Button variant="outlined" component="span" size="small" color={errors.personalPhoto ? "error" : "primary"}>
                {previewUrl ? 'Change Photo' : 'Upload Photo*'}
              </Button>
            </label>
            {errors.personalPhoto && (
              <FormHelperText error>{errors.personalPhoto}</FormHelperText>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Date of Birth"
              type="date"
              fullWidth
              value={formData.personalDetails.dateOfBirth}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => handleChange(e, 'personalDetails', 'dateOfBirth')}
              required
              error={!!errors.dateOfBirth}
              helperText={errors.dateOfBirth}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Anniversary"
              type="date"
              fullWidth
              value={formData.personalDetails.anniversary}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => handleChange(e, 'personalDetails', 'anniversary')}
            />
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                  <TextField
                    label={`${nationalIdLabel} Number`}
                    fullWidth
                    value={formData.personalDetails.panNumber}
                    onChange={(e) => handleChange(e, 'personalDetails', 'panNumber')}
                    required
                    error={!!errors.panNumber}
                    helperText={errors.panNumber}
                  />
                  {(!companyCountry || companyCountry.toLowerCase() === "india") && (
                    <FieldTooltip title="Format: ABCDE1234F (5 letters, 4 numbers, 1 letter)" />
                  )}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="body2" gutterBottom>
                    {nationalIdLabel} File*
                    <FieldTooltip title={`Upload a scanned copy of ${nationalIdLabel} (PDF/JPEG/PNG)`} />
                  </Typography>
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handleFileUpload(e, 'personalDetails', 'panCardFile')}
                  />
                  {formData.personalDetails.panCardFile && typeof formData.personalDetails.panCardFile === 'string' && (
                    <Typography variant="caption" sx={{ mt: 1 }}>
                      Current File: <a href={formData.personalDetails.panCardFile.startsWith('http') ? formData.personalDetails.panCardFile : `${API_URL}/uploads/${formData.personalDetails.panCardFile}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline' }}>{cleanFileName(formData.personalDetails.panCardFile)}</a>
                    </Typography>
                  )}
                  {errors.panCardFile && (
                    <FormHelperText error>{errors.panCardFile}</FormHelperText>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {(!companyCountry || companyCountry.toLowerCase() === "india") && (
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    <TextField
                      label="Aadhar Card Number"
                      fullWidth
                      value={formData.personalDetails.adharCardNumber}
                      onChange={(e) => handleChange(e, 'personalDetails', 'adharCardNumber')}
                      required
                      error={!!errors.adharCardNumber}
                      helperText={errors.adharCardNumber}
                    />
                    <FieldTooltip title="Format: 12 digits (e.g., 123456789012)" />
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2" gutterBottom>
                      Aadhar Card File*
                      <FieldTooltip title="Upload a scanned copy of Aadhar card (PDF/JPEG/PNG)" />
                    </Typography>
                    <input
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png"
                      onChange={(e) => handleFileUpload(e, 'personalDetails', 'adharCardFile')}
                    />
                    {formData.personalDetails.adharCardFile && typeof formData.personalDetails.adharCardFile === 'string' && (
                      <Typography variant="caption" sx={{ mt: 1 }}>
                        Current File: <a href={formData.personalDetails.adharCardFile.startsWith('http') ? formData.personalDetails.adharCardFile : `${API_URL}/uploads/${formData.personalDetails.adharCardFile}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline' }}>{cleanFileName(formData.personalDetails.adharCardFile)}</a>
                      </Typography>
                    )}
                    {errors.adharCardFile && (
                      <FormHelperText error>{errors.adharCardFile}</FormHelperText>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Paper>

      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Contact Information
          <FieldTooltip title="Current residential address and contact details" />
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <TextField
                label="Phone Number"
                fullWidth
                value={formData.contactInfo.phoneNumber}
                onChange={(e) => handleChange(e, 'contactInfo', 'phoneNumber')}
                required
                error={!!errors.phoneNumber}
                helperText={errors.phoneNumber}
              />
              <FieldTooltip title="10-digit mobile number without country code" />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="House Number"
              fullWidth
              value={formData.contactInfo.houseNumber}
              onChange={(e) => handleChange(e, 'contactInfo', 'houseNumber')}
              required
              error={!!errors.houseNumber}
              helperText={errors.houseNumber}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Street"
              fullWidth
              value={formData.contactInfo.street}
              onChange={(e) => handleChange(e, 'contactInfo', 'street')}
              required
              error={!!errors.street}
              helperText={errors.street}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="State"
              fullWidth
              value={formData.contactInfo.state}
              onChange={(e) => handleChange(e, 'contactInfo', 'state')}
              required
              error={!!errors.state}
              helperText={errors.state}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Area"
              fullWidth
              value={formData.contactInfo.area}
              onChange={(e) => handleChange(e, 'contactInfo', 'area')}
              required
              error={!!errors.area}
              helperText={errors.area}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="City"
              fullWidth
              value={formData.contactInfo.city}
              onChange={(e) => handleChange(e, 'contactInfo', 'city')}
              required
              error={!!errors.city}
              helperText={errors.city}
            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <TextField
                label="Pin Code"
                fullWidth
                value={formData.contactInfo.pinCode}
                onChange={(e) => handleChange(e, 'contactInfo', 'pinCode')}
                required
                error={!!errors.pinCode}
                helperText={errors.pinCode}
              />
              <FieldTooltip title="6-digit postal code" />
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Emergency Contact
          <FieldTooltip title="Contact details in case of emergency" />
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <TextField
                label="Mobile"
                fullWidth
                value={formData.emergencyContact.mobile}
                onChange={(e) => handleChange(e, 'emergencyContact', 'mobile')}
                required
                error={!!errors.emergencyMobile}
                helperText={errors.emergencyMobile}
              />
              <FieldTooltip title="10-digit mobile number of emergency contact" />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Landline"
              fullWidth
              value={formData.emergencyContact.landline}
              onChange={(e) => handleChange(e, 'emergencyContact', 'landline')}
              error={!!errors.emergencyLandline}
              helperText={errors.emergencyLandline}
            />
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Health Information
          <FieldTooltip title="Insurance details to be filled by company" />
        </Typography>
        {errors.insurance && (
          <Typography variant="body2" color="error" sx={{ mb: 2 }}>
            {errors.insurance}
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Individual Insurance"
              fullWidth
              value={formData.insurance.individualInsurance}
              onChange={(e) => handleChange(e, 'insurance', 'individualInsurance')}
              required
              error={!!errors.individualInsurance}
              helperText={errors.individualInsurance}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Group Insurance"
              fullWidth
              value={formData.insurance.groupInsurance}
              onChange={(e) => handleChange(e, 'insurance', 'groupInsurance')}
              required
              error={!!errors.groupInsurance}
              helperText={errors.groupInsurance}
            />
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Nominations
          <FieldTooltip title="Add beneficiary/nominee details for company benefits" />
        </Typography>
        {errors.nominations && (
          <Typography variant="body2" color="error" sx={{ mb: 2 }}>
            {errors.nominations}
          </Typography>
        )}
        {formData.nominations.map((nomination, index) => (
          <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
            <Grid item xs={4}>
              <TextField
                label="Name"
                fullWidth
                value={nomination.name}
                onChange={handleArrayChange('nominations', index, 'name')}
                required
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel>Relationship</InputLabel>
                <Select
                  value={nomination.relationship}
                  onChange={handleArrayChange("nominations", index, "relationship")}
                  label="Relationship"
                  required
                >
                  <MenuItem value="Spouse">Spouse</MenuItem>
                  <MenuItem value="Parent">Parent</MenuItem>
                  <MenuItem value="Child">Child</MenuItem>
                  <MenuItem value="Sibling">Sibling</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Age"
                fullWidth
                type="number"
                value={nomination.age}
                onChange={handleArrayChange('nominations', index, 'age')}
                required
              />
            </Grid>
          </Grid>
        ))}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => addEntry('nominations', { name: '', relationship: '', age: '' })}
          sx={{ mt: 1 }}
        >
          Add Nominee
        </Button>
      </Paper>

      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Qualifications
          <FieldTooltip title="Educational qualifications with supporting documents" />
        </Typography>
        {errors.qualifications && (
          <Typography variant="body2" color="error" sx={{ mb: 2 }}>
            {errors.qualifications}
          </Typography>
        )}
        {formData.qualifications.map((qualification, index) => (
          <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
            <Grid item xs={3}>
              <TextField
                label="Degree/Diploma"
                fullWidth
                value={qualification.degree}
                onChange={handleArrayChange('qualifications', index, 'degree')}
                required
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Institution"
                fullWidth
                value={qualification.institution}
                onChange={handleArrayChange('qualifications', index, 'institution')}
                required
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Year of Completion"
                fullWidth
                value={qualification.year}
                onChange={handleArrayChange('qualifications', index, 'year')}
                required
              />
            </Grid>
            <Grid item xs={3}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="body2" gutterBottom>
                  Certificate
                </Typography>
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleArrayFileUpload('qualifications', index, 'file')}
                />
                {qualification.file && typeof qualification.file === 'string' && (
                  <Typography variant="caption" sx={{ mt: 1 }}>
                    Current File: <a href={qualification.file.startsWith('http') ? qualification.file : `${API_URL}/uploads/${qualification.file}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline' }}>{cleanFileName(qualification.file)}</a>
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        ))}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => addEntry('qualifications', { degree: '', institution: '', year: '', file: null })}
          sx={{ mt: 1 }}
        >
          Add Qualification
        </Button>
      </Paper>

      <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Certificates and Achievements
          <FieldTooltip title="Professional certifications and achievements" />
        </Typography>
        {errors.certificates && (
          <Typography variant="body2" color="error" sx={{ mb: 2 }}>
            {errors.certificates}
          </Typography>
        )}
        {formData.certificates.map((certificate, index) => (
          <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
            <Grid item xs={3}>
              <TextField
                label="Certificate Name"
                fullWidth
                value={certificate.name}
                onChange={handleArrayChange('certificates', index, 'name')}
              
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Issued By"
                fullWidth
                value={certificate.issuedBy}
                onChange={handleArrayChange('certificates', index, 'issuedBy')}
           
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Date of Issue"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={certificate.date}
                onChange={handleArrayChange('certificates', index, 'date')}
          
              />
            </Grid>
            <Grid item xs={3}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="body2" gutterBottom>
                  Certificate
                </Typography>
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleArrayFileUpload('certificates', index, 'file')}
                />
                {certificate.file && typeof certificate.file === 'string' && (
                  <Typography variant="caption" sx={{ mt: 1 }}>
                    Current File: <a href={certificate.file.startsWith('http') ? certificate.file : `${API_URL}/uploads/${certificate.file}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline' }}>{cleanFileName(certificate.file)}</a>
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        ))}
        <Button
          variant="outlined"
          color="primary"
          onClick={() => addEntry('certificates', { name: '', issuedBy: '', date: '', file: null })}
          sx={{ mt: 1 }}
        >
          Add Certificate
        </Button>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          {isEditMode ? "Update & Continue" : "Save & Continue"}
        </Button>
      </Box>
    </Box>
  );
};

export default Addpersonal;